import axios from 'axios';
import React, { useState, useEffect } from 'react';

import SelectComponent from '../common/select';
import OptionComponent from '../common/option';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_collarshaped'
});

const productId = document.getElementById('mtm-customize').dataset.productId;

const MtmCollar = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const getList = async () => {
      const response = await client.get('?product_id=' + productId);
      setList(response.data.result);
    };
    getList();
  }, []);

  if (!list) return 'No collars!';

  return (
    <div className="mtm-item__wrapper active" id="mtm-collars">
      <h3 className="mtm-item__title">COLLARS</h3>
      <div className="mtm-item__selects row row-cols-2 row-cols-md-5">
        {list.map((item, ind) => (
          <SelectComponent
            item={item}
            ind={ind}
            name="collar"
            option_type={item.cleric_type.length}
            key={`${item.value}-${ind}`}
          />
        ))}
      </div>
      <div className="mtm-item__options" id="mtm-collars__option">
        {Object.keys(list).map((item, ind) => {
          return (
            <div
              className="options-item mtm-item__selects row"
              data-collars={list[item].value}
              key={`collars-sel-${ind}`}
            >
              {list[item].cleric_type.map((cleric, ind) => (
                <OptionComponent
                  cleric={cleric}
                  ind={ind}
                  parent="collar"
                  name="cleric_type"
                  key={`cleric-${ind}`}
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MtmCollar;
